import { render, staticRenderFns } from "./WithdrawalMyPageDialog.vue?vue&type=template&id=0675e621"
import script from "./WithdrawalMyPageDialog.vue?vue&type=script&lang=js"
export * from "./WithdrawalMyPageDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports